import { jsx } from "react/jsx-runtime";
import { FloatingControls, TableControls } from "./components/Controls/index.js";
import { useControlsActions } from "./hooks/useControlsActions.js";
function useControls(initialState, options = {}) {
  const { floating, renderControls } = options;
  const { schema, values, updateSchema, setField, resetFields } = useControlsActions(initialState);
  const controls = floating ? /* @__PURE__ */ jsx(FloatingControls, { options, setField, state: schema }) : /* @__PURE__ */ jsx(TableControls, { options, setField, state: schema });
  return {
    controls: renderControls ? renderControls(schema, setField) : controls,
    resetFields,
    schema,
    setField,
    updateSchema,
    values
  };
}
export {
  useControls
};
//# sourceMappingURL=useControls.js.map
